import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[ngx-datatable-cell-template]'
})
export class DataTableColumnCellDirective {
  template = inject<TemplateRef<unknown>>(TemplateRef);

}
